import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, roles }) => {
  // const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    return <h2 style={{ textAlign: "center", marginTop: "50px" }}>
      You are not authorised
    </h2>;
  }

  if (!roles.includes(user.role.toString())) {
    return <h2 style={{ textAlign: "center", marginTop: "50px" }}>
      Access denied
    </h2>;
  }

  return children;
};

export default ProtectedRoute;